import { customAlphabet, nanoid } from "nanoid";

export type WMUIdsAPI = {
  next: (size?: number) => string;
  nextOpaque: (size?: number) => string;
  nextPrefixed: (prefix: string, size?: number) => string;
  nextShort: (prefix?: string) => string;
  normalizePrefix: (prefix: string, fallback?: string) => string;
};

const SAFE_ID_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

export function normalizeIDPrefix(prefix: string, fallback = "id"): string {
  return String(prefix || "")
    .replace(/[^a-z0-9_]+/gi, "_")
    .replace(/^_+|_+$/g, "")
    .toLowerCase() || fallback;
}

export function nextOpaqueID(size = 21): string {
  return nanoid(size);
}

export function nextPrefixedID(prefix: string, size = 12): string {
  const safePrefix = normalizeIDPrefix(prefix);
  const nextToken = customAlphabet(SAFE_ID_ALPHABET, Math.max(6, Number(size) || 12));
  return `${safePrefix}_${nextToken()}`;
}

window.WMUIds = {
  next: nextOpaqueID,
  nextOpaque: nextOpaqueID,
  nextPrefixed: nextPrefixedID,
  nextShort: (prefix = "id") => nextPrefixedID(prefix, 12),
  normalizePrefix: normalizeIDPrefix,
} satisfies WMUIdsAPI;
